<template>
  <div class="error__wrapper">
    <h2 class="error__title title title-border uppercase">
      Oops! Page Not Found
    </h2>
    <p class="error__text text-body">
      It looks like the page you're trying to reach doesn't exist.
    </p>
    <p class="error__text text-body">
      But don't worry, we've got you covered! Here are a few things you can try:
    </p>
    <ul class="error__list">
      <li class="error__item text-body">
        Check the URL: Make sure the web address is correct.
      </li>
      <li class="error__item text-body">
        Go to the Homepage: Start fresh from
        <a-link :to="$options.consts.MAIN_ROUTE">our main page</a-link>.
      </li>
      <li></li>
    </ul>
  </div>
</template>

<script>
import { MAIN_ROUTE } from 'enums/main-route'

export default {
  name: 'ErrorPage',
  layout: 'empty',
  consts: {
    MAIN_ROUTE
  }
}
</script>

<style lang="scss" scoped>
.error__wrapper {
  padding-top: 52px;
}

.error__title {
  margin-bottom: 32px;
}

.error__text {
  margin-bottom: 20px;
}

.error__list {
  padding-left: 10px;
}

.error__item {
  margin-bottom: 0;
  margin-left: 15px;

  @include bullet(30px, 5.5px, 20px);

  @include mobile {
    @include bullet(30px, 5px, 20px);
  }
}
</style>
